export default __webpack_public_path__ + "24f89623996a51f1c59b1de7158852ad.webp";